import { Models } from '@mtap-smartcity/api';

interface GraphsState {
  graphs: Array<Models.ScenarioGraphs.Model>,
}

enum GraphsGetter {
  GetGraph = 'GET_GRAPH'
}

type GraphsGetterType = {
  [GraphsGetter.GetGraph]: (uuid: string) => Models.ScenarioGraphs.Model | undefined
}

enum GraphsAction {
  FetchGraphs = 'FETCH_GRAPHS',
  CreateGraph = 'CREATE_GRAPH',
  UpdateGraph = 'UPDATE_GRAPH',
  DeleteGraph = 'DELETE_GRAPH'
}

type GraphsActionType = {
  [GraphsAction.FetchGraphs]: (payload?: { unixTime: number }) => Promise<void>,
  [GraphsAction.CreateGraph]: (graph: Models.ScenarioGraphs.Model) => Promise<Models.ScenarioGraphs.Model | void>,
  [GraphsAction.UpdateGraph]: (graph: Models.ScenarioGraphs.Model) => Promise<void>,
  [GraphsAction.DeleteGraph]: (uuid: string) => Promise<void>,
}

export {
  GraphsState,
  GraphsGetter,
  GraphsGetterType,
  GraphsAction,
  GraphsActionType
};
